<table class="table table-responsive-md table-striped" style="width: 100%;">
  <thead>
  <tr>
    <th *ngFor="let tableAttribute of tableAttributes"
        id="table-column-header-{{tableAttribute?.header}}"
        scope="col">{{tableAttribute?.header}}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let tableRowObject of tableRowObjects; let i = index "
      (click)="onRowClick(tableRowObject)">
    <td *ngFor="let tableAttribute of tableAttributes;">
        <span
          [ngClass]="(tableAttribute?.header.toUpperCase() === 'STATUS') ?
           ((tableRowObject[tableAttribute?.accessor?.main].toUpperCase() === 'FAILED') ?
           'status-column-failed' : 'status-column-success') : 'status-column-default'"
          *ngIf="!tableAttribute?.accessor?.sub; else nestedProperty">
          {{tableAttribute?.containsDate ?
          (tableRowObject[tableAttribute?.accessor?.main] | date: 'dd-MM-yyyy') :
          tableRowObject[tableAttribute?.accessor?.main]}}
        </span>
      <ng-template #nestedProperty>
        {{tableAttribute?.containsDate ?
        (tableRowObject[tableAttribute?.accessor?.main][tableAttribute?.accessor?.sub] | date: 'dd-MM-yyyy') :
        tableRowObject[tableAttribute?.accessor?.main][tableAttribute?.accessor?.sub]}}
      </ng-template>
    </td>
  </tr>
  </tbody>
</table>
